import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import DesktopHeader from "@/components/layout/DesktopHeader";
import MobileHeader from "@/components/layout/MobileHeader";
import MobileBottomNav from "@/components/layout/MobileBottomNav";
import Footer from "@/components/layout/Footer";
import AiWidget from "@/components/ai/AiWidget";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import PublicationsBanner from "@/components/PublicationsBanner";
import PromoPopup from "@/components/PromoPopup";

export function SiteLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <AnnouncementBanner />
      <PublicationsBanner />
      <DesktopHeader />
      <MobileHeader />
      <main className="flex-1 pb-20 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileBottomNav />
      <AiWidget />
      <PromoPopup />
    </div>
  );
}

export default SiteLayout;
